import SetPasswordScreen from "./SetPasswordScreen";

export default function SetPassword() {
  return <SetPasswordScreen mode="invite" />;
}
